import React from 'react'
import MagazineStageSimple from '../../Components/MagazineStageSimple/MagazineStageSimple'
import MagazineTextBlock from '../../Components/MagazineTextBlock/MagazineTextBlock';
import imgXCode from '../../assets/news-events/x_code_identify_hoses/Capa.png'
import imgDestacada from '../../assets/news-events/x_code_identify_hoses/Destacada.png'
import imgImagem1 from '../../assets/news-events/x_code_identify_hoses/Imagem 1.png'
import imgImagem2 from '../../assets/news-events/x_code_identify_hoses/Imagem 2.png'
import imgPost from '../../assets/news-events/x_code_identify_hoses/Post.png'
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const XCodeNews = () => {
    const { t } = useTranslation();
    const ogTitle = t('X-CODE HANSA-FLEX');
    const ogDescription = t('Reduce downtime with X-CODE HANSA-FLEX. Ensure full traceability, precise replacement of hydraulic hoses, and maintenance efficiency.');
    const ogImage = `https://www.hansa-flex.com.br/${imgXCode}`;
    const ogUrl = `https://www.hansa-flex.com.br/x_code_identify_hoses_in_seconds`;

    return (
        <div>
            <Helmet>
                <meta property="og:title" content={ogTitle} />
                <meta property="og:description" content={ogDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={ogUrl} />
                <meta property="og:type" content="News" />
            </Helmet>

            <MagazineStageSimple
                imageSrc={imgXCode}
                imageAlt="X-Code: Identify hoses in seconds"
                meta="18.03.2026 | Gabriela Nascimento"
                title="X-CODE: Identify hoses in seconds"
                text="Imagine your machine coming to a halt in the middle of a shift because a hose has burst. The operator faces a dilemma: try a makeshift repair and risk safety, or wait hours for a technician? This scenario of uncertainty erodes your operation’s profits. But what if the solution to this problem were right at your fingertips, even before the failure occurs?"
                // tags={['X-Code', 'Identify hoses', 'Seconds']}
                readingTimeMinutes={5}
            />

            <MagazineTextBlock
                title="X-CODE HANSA-FLEX: No More Losses from Burst Hoses"
                paragraphs={[
                    "In the field, time isn’t just money—it’s lost productivity that never comes back. When a hydraulic hose fails, the challenge isn’t just replacing it, but correctly identifying the part. Getting the diameter, pressure, or connection type wrong means safety risks, rework, and more downtime.",
                    "HANSA-FLEX solves this bottleneck with X-CODE, an intelligent traceability system that transforms each component into a unique digital identity. With it, operator uncertainty gives way to the absolute precision of German engineering, ensuring that the replacement is identical to the original, without the need for complex manual measurements in the field."
                ]}
            />

            <MagazineTextBlock
                imageSrc={imgImagem1}
                imageAlt="Imagem 1"
                title="How the technology that revolutionized maintenance works"
                paragraphs={[
                    "X-CODE is a six-digit alphanumeric code permanently affixed to the hose. It acts as the component’s “DNA.” By entering this code at any HANSA-FLEX location or by logging into X-CODE Manager, you instantly gain access to more than 48 pieces of information about the hose.",
                    "This system has been proven in practice millions of times worldwide, establishing itself as the gold standard in fleet management and high-performance hydraulic systems."
                ]}
            />

            <MagazineTextBlock
                title="Turning data into operational agility"
                paragraphs={[
                    "The traceability of X-CODE goes beyond a simple label. For harsh environments such as mining and offshore, identification can be done via self-adhesive labels or stainless steel plates. For companies pursuing Industry 4.0, we offer integration with QR codes and RFID chips, enabling automated machine reading.",
                    "This data is centralized and can be managed through the X-CODE Manager software. This allows maintenance managers to move beyond “firefighting” and enter the era of preventive maintenance, monitoring the lifecycle of each hose and scheduling replacements before failure occurs."
                ]}
            />

            <MagazineTextBlock
                imageSrc={imgImagem2}
                imageAlt="Imagem 2"
                title="Immediate benefits for your field team"
                bulletPoints={[
                    { point: "Instant Identification:", paragraph: "No more calipers or guesswork. Just scan and identify." },
                    { point: "Error-Free Ordering:", paragraph: "The code ensures 100% compatibility in the manufacture of the replacement part." },
                    { point: "Faster Logistics:", paragraph: "The right part arrives at the job site as quickly as possible." },
                    { point: "Digital History:", paragraph: "Have full control over when each component was installed and its expected service life." },
                ]}
                    bulletType="numbers"
            />

            <MagazineTextBlock
                title="Your operation deserves maximum uptime"
                paragraphs={[
                    "Operational continuity should not depend on luck or the ability to improvise in the field. With X-CODE technology, HANSA-FLEX Brazil delivers the latest in traceability and safety for hydraulic systems. If you’re looking to reduce costs from unplanned downtime and want to professionalize your asset management, the time to act is now.",
                ]}
            />

            <MagazineTextBlock
                boldPara="Want to eliminate machine downtime at your company?"
                paragraphs={[
                    "Contact our experts and implement X-CODE in your company!"
                ]}
                buttonName="Our branches"
                buttonLink="/contact-us"
            />
            <div style={{ backgroundColor: '#f8f8f8'}}>
            <br /><br /><br />
            </div>
        </div>
    );
};

export default XCodeNews;